<template>
	<div class="visitor-discern">
		<!-- 网站访客识别 -->
		<div class="page-header card">
			<select-date
				ref="selectDate"
				title="网站访客识别"
				:selecttimetype="selecttimetype"
				:websiteList="websiteList"
				:disabled="dateDisabled"
				:groups="groups"
				@filterChange="filterPanelChange"
				@changeData="changeData"
				@changeType="changeType"
			>
			</select-date>
		</div>

		<div class="visitor-data-preview card">
			<client-module :hideBorder="true">
				<span slot="moduletitle" style="font-size: 16px">数据总览</span>

				<div class="data-preview-wrap">
					<div class="icon-data-wrap">
						<icon-data
							iconOuterColor="#F9EAEE"
							iconColor="#FF89A8"
							iconName="zongshibieshu1"
							label="总识别数"
							:value="VisitorData.total"
						></icon-data>
						<div style="width: 55px"></div>
						<icon-data
							iconOuterColor="#E8F7E9"
							iconColor="#98E09C"
							iconName="pingjunmeirishibie1"
							label="平均每日识别"
							:value="VisitorData.average"
						></icon-data>
					</div>
					<div class="chart-data-wrap">
						<p>热门国家Top5</p>
						<div class="chart-list">
							<div v-if="!showProgress" style="margin-bottom: 22px">暂无数据</div>
							<div
								class="data-top"
								v-for="(item, index) in VisitorData.visitorCountryList"
								:key="item.name"
							>
								<div class="progress" :class="`progress${index}`">
									{{ item.nameCh || item.name || '-' }}
								</div>
								<div class="data">{{ item.countryTotal || 0 }}</div>
							</div>
						</div>
					</div>
				</div>
			</client-module>
		</div>

		<div class="btn-row" style="text-align: right; padding: 20px">
			<el-button type="primary" :disabled="dateDisabled" @click="download">导出</el-button>
		</div>

		<data-list
			:data="data"
			:columns="column"
			:page="page"
			:table-style="{ name: 'mixture' }"
			:page-size="page.pageSize"
			:loading="loading"
			@page-size-changed="pageSizeChanged"
			@page-changed="pageChanged"
			@sort-change="sortChange"
		>
		</data-list>
	</div>
</template>

<script>
import clientModule from '@/components/client/clientModule/clientModule';
// import skyDropdownSelect from '@/components/iglobalwin/formComponents/sky-dropdownSelect'
// import filterPanel from '@/components/iglobalwin/filterPanelNew/filterPanel.vue'
import iconData from '@/components/setting/iconData.vue';
import listPageCreate from '@/mixins/listPageCreate';
import api from '@/backend/apiConfig/apiConfig';
import { mapGetters } from 'vuex';
import { getWebsiteByCustomer } from '@/backend/services/account/service';
import visitor from '@/backend/services/visitor';
import selectDate from '@/components/selsectDate/selectDate.vue';

const list = listPageCreate({
	searchConfig: {
		api: api.visitor.visitorList,
		method: 'POST',
	},
	getQuery(obj, that) {
		let { startDate, endDate, serviceId, groups } = that;
		return _.assign(obj, {
			beginDate: startDate,
			endDate: endDate,
			serviceId,
			customerName: groups.others[0].value,
		});
	},
});
export default {
	name: 'visitorDiscern',
	mixins: [list],
	components: {
		clientModule,
		// skyDropdownSelect,
		// filterPanel,
		iconData,
		selectDate,
	},
	data() {
		return {
			siteId: '',
			websiteList: [],
			serviceId: '',
			groups: {
				others: [
					{
						tagName: 'sky-input',
						inputTitle: '公司名称',
						placeholder: '公司名称',
						label: '公司名称',
						prop: 'versionNum',
						clearable: true,
						value: '',
					},
				],
			},
			column: [],
			startDate: '',
			endDate: '',
			customerName: '',
			VisitorData: {},
			dateDisabled: false,
			selecttimetype: 'DAILY',
		};
	},
	computed: {
		...mapGetters(['customerId']),
		showProgress() {
			let { visitorCountryList } = this.VisitorData;
			return visitorCountryList && visitorCountryList.length !== 0;
		},
	},
	methods: {
		changeType(val) {
			return new Promise(res => {
				this.selecttimetype = val;
				res(val);
			});
		},
		format(percentage) {
			return percentage;
		},
		// 网站下拉数据
		async getWebsite(id) {
			try {
				let result = await getWebsiteByCustomer({
					customerId: id,
				});
				this.websiteList = result.data;
				if (result.data.length == 0) {
					this.serviceId = '';
					return false;
				}
				this.serviceId = result.data[0].id;

				this.dateDisabled = false;
				this.setColumn();
			} catch (error) {
				this.dateDisabled = true;
				this.setColumn();
			}
		},
		// 筛选条件改变
		changeData(val) {
			this.startDate = val.startDate;
			this.endDate = val.endDate;
			this.serviceId = val.serviceId;
			this.resetPage();
			this.query();
			this.getVisitorDataStats();
		},
		// 获取数据统计
		async getVisitorDataStats() {
			let { startDate, endDate, serviceId, groups } = this;
			let res = await visitor.visitorDataStats({
				beginDate: startDate,
				endDate: endDate,
				serviceId,
				customerName: groups.others[0].value,
			});
			this.VisitorData = res.data;
		},
		setColumn() {
			let that = this;
			this.column = [
				{
					label: '',
					bind: 'logoUrl',
					type: 'photo',
					width: 100,
					style: {
						width: '50px',
						height: '50px',
						borderRadius: '6px',
					},
					formatter(val) {
						if (val) return val;
						let imgUrl = require('@/assets/defaultLogo.png');
						if (imgUrl.default) {
							return imgUrl.default;
						} else {
							return imgUrl;
						}
					},
				},
				{
					label: '公司名称',
					bind: 'companyName',
					showOverflowTooltip: true,
				},
				{
					label: '公司网站',
					type: 'custInfo',
					main: 'websiteUrl',
					minWidth: 120,
					event(row) {
						if (row.websiteUrl) window.open(`${row.websiteUrl}`);
					},
				},
				{
					label: '地区',
					bind: 'address',
					minWidth: 120,
					showOverflowTooltip: true,
				},
				{
					label: '行业',
					bind: 'industryCh',
					showOverflowTooltip: true,
				},
				// {
				// 	label: '访客质量',
				// 	bind: 'quality',
				// 	content:
				// 		'访客识别质量由公司信息详细程度、访问次数综合判断的，满分 10 分，常规公司信息越详细，访问次数多的分数越高。',
				// },
				{
					label: '累计访问次数',
					bind: 'viewNum',
					sort: 'viewNum',
					options: [
						{
							label: '由低到高',
							value: 'asc',
						},
						{
							label: '由高到低',
							value: 'desc',
						},
					],
				},
				{
					label: '累计访问时长',
					bind: 'visitLengthStr',
					sort: 'visitLength',
					options: [
						{
							label: '由低到高',
							value: 'asc',
						},
						{
							label: '由高到低',
							value: 'desc',
						},
					],
				},
				{
					label: '最近浏览',
					bind: 'lastVisitDate',
					showOverflowTooltip: true,
					type: 'percentage',
					dataStyle(val) {
						if (val) return val.slice(0, 10);
						return '-';
					},
					sort: 'lastVisitDate',
					options: [
						{
							label: '由低到高',
							value: 'asc',
						},
						{
							label: '由高到低',
							value: 'desc',
						},
					],
				},
				{
					label: '操作',
					type: 'btnClick',
					style: 'text',
					bind: () => {
						return [
							{
								text: '查看详情',
								trigger(row) {
									that.$router.push({
										name: 'visitorDetails',
										query: {
											id: row.visitorId,
											serviceId: that.serviceId,
											isurl: !!row.websiteUrl,
										},
									});
								},
							},
						];
					},
				},
			];
		},
		filterPanelChange() {
			this.filterChange();
			this.getVisitorDataStats();
		},
		async download() {
			let { startDate, endDate, serviceId, page, groups } = this;
			let res = await visitor.dataExport({
				beginDate: startDate,
				endDate,
				serviceId,
				customerName: groups.others[0].value,
			});
			let blob = new Blob([res.data]);
			let url = window.URL.createObjectURL(blob);
			let link = document.createElement('a');
			link.style.display = 'none';
			link.href = url;
			link.setAttribute('download', `${name}【${this.startDate}至${this.endDate}】.xlsx`);
			document.body.appendChild(link);
			link.click();
		},
	},
	watch: {
		customerId: {
			async handler(val) {
				let id = this.$route.query.id;
				let name = this.$route.query.name;
				if (id && name) {
					this.$store.commit('SET_CUSTOMERID', id);
					this.$store.commit('SET_CUSOMERNAME', name);
				}

				if (val || (id && name)) {
					this.getWebsite(val);
					this.dateDisabled = false;
				} else {
					this.dateDisabled = true;
					this.setColumn();
					this.$message.warning('您需要先选择一个客户');
					this.websiteList = [];
					this.serviceId = '';
					this.VisitorData = {};
					this.data = [];
					this.startDate = '';
				}
			},
			immediate: true,
		},
	},
	activated() {
		if (this.customerId && this.serviceId) {
			this.query();
		}
	},
};
</script>

<style lang="scss">
.visitor-discern {
	.card {
		background-color: white;
		box-shadow: 0 2px 6px 0 #e9ecf8;
		border-radius: 4px;
	}

	.site-select {
		margin-left: 20px;
		color: #5aa0ff;
	}

	.filterMultiple {
		padding-top: 0 !important;
	}

	.data-preview-wrap {
		display: flex;
		padding: 20px 0;
	}

	.icon-data-wrap {
		display: flex;
		padding: 40px;
		border-right: 1px solid #e8e8e8;
	}

	.chart-data-wrap {
		flex: 1;
		padding-left: 38px;

		.chart-list {
			width: 100%;
			height: 145px;
			display: flex;
			justify-content: flex-start;
			align-items: flex-start;
			flex-direction: column;
			flex-wrap: wrap;
			padding: 25px 20px 10px;

			.data-top {
				width: 45%;
				height: 26px;
				line-height: 26px;
				margin-bottom: 10px;

				.progress {
					float: left;
					height: 100%;
					padding: 0 10px;
					border-radius: 3px;
					background-color: #ddecfe;
					color: #333;
					white-space: nowrap;

					&.progress0 {
						width: 70%;
					}

					&.progress1 {
						width: 50%;
					}

					&.progress2 {
						width: 30%;
					}

					&.progress3 {
						width: 20%;
					}

					&.progress4 {
						width: 10%;
					}
				}

				.data {
					float: right;
				}
			}
		}

		.chart-item {
			display: flex;

			&-title {
				text-align: right;
				margin-right: 10px;
				white-space: nowrap;
			}

			&-progress {
				width: 90%;
				padding-right: 30px;
			}
		}
	}
}
</style>
